export const initializeSessionEvent = async () => {
  async function sendEvent() {
    await window.eventBus.publish("WS_OUT", {
      action: "message",
      data: {
        event: "CLIENT_EVENTS",
        events: [{ eventType: "NEW_SESSION" }],
      },
    });
  }

  async function handleInteraction() {
    const last_interaction = sessionStorage.getItem("gx_last_interaction");

    const moment = new Date().getTime();
    sessionStorage.setItem("gx_last_interaction", `${moment}`);

    if (last_interaction === null || moment - Number(last_interaction) > 1000 * 60 * 30) {
      await sendEvent();
    }
  }

  ["click", "keyup", "touchstart", "scroll"].forEach((event) => {
    window.addEventListener(event, handleInteraction);
  });

  await window.eventBus.subscribe("SESSION_EVENT_LOAD", sendEvent);
};
